<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 11.3333L8 7.33325L4 11.3333" stroke="#0071FA" stroke-width="2"/>
        <path d="M4.6665 4L11.3332 4" stroke="#0071FA" stroke-width="2"/>
    </svg>
</template>
<script setup lang="ts">
</script>